import { api } from './client'

export const authApi = {
  login: (email: string, password: string) =>
    api.post<{ accessToken: string }>('/auth/login', { email, password }),

  logout: () => api.post('/auth/logout'),

  acceptInvite: (email: string, token: string, password: string) =>
    api.post('/auth/invite/accept', { email, token, password }),
}
